import { Button, Col, Modal, Row, Text } from 'components';
import { logout } from 'lib';
import { useTranslation } from 'react-i18next';

const LogoutModal = ({ visible, closeModal, navigate }) => {
  const { t } = useTranslation();

  return (
    <Modal visible={visible} closeModal={closeModal}>
      <Col pad="64px" center>
        <Col centerAll wid="100%">
          <Text h3 center>
            {t('common.logOut')}
          </Text>

          <Row maxWid="296px">
            <Text center marg="18px 0 0">
              {t('header.logOutConfirmation')}
            </Text>
          </Row>
        </Col>

        <Row marg="30px 0 0">
          <Button
            big
            text={t('common.logOut')}
            marg="0 12px 0 0"
            onClick={() => logout(navigate)}
          />

          <Button big bordered text={t('common.cancel')} onClick={closeModal} />
        </Row>
      </Col>
    </Modal>
  );
};

export default LogoutModal;
